import React from 'react';
import Hero from '../components/UI/Hero';
import ProjectCard from '../components/Cards/ProjectCard';
import { projects } from '../data/projects';
import heroImage from '../assets/optimized/asset7.webp';
import './ProjectsPage.css';

const ProjectsPage = () => {
  return (
    <div className="projects-page">
      <Hero
        image={heroImage}
        title="Our Projects"
        subtitle="A collection of applications, games, and solutions we've built over the years."
        size="medium"
      />

      <section className="projects-grid-section">
        <div className="container">
          <div className="all-projects-grid">
            {projects.map((project) => (
              <ProjectCard
                key={project.id}
                title={project.title}
                description={project.description}
                image={project.image}
                tags={project.tags}
                link={project.link}
                externalLink={project.externalLink}
              />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProjectsPage;
